/**
 * SideMenu
 */

// React
import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

// UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  ListItem,
  Collapse,
  ListItemIcon,
  ListItemText,
  Drawer,
  Divider,
  List,
  Avatar,
  DialogTitle,
  DialogActions,
  Dialog,
  Button,
  IconButton,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiExitToApp,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiClipboardArrowLeftOutline,
  mdiChevronDown,
  mdiChevronUp,
  mdiCar,
  mdiMenu,
  mdiChevronRight,
  mdiAccountMultipleOutline,
  mdiHandshake,
  mdiWarehouse,
  mdiClose,
  mdiCounter,
  mdiMapMarkerRadiusOutline,
  mdiArchive,
  mdiArchiveOutline,
  mdiClipboardArrowUpOutline,
  mdiAccountSupervisor,
  mdiWeb,
  mdiClipboardListOutline,
  mdiHistory,
  mdiStarBoxMultipleOutline,
  mdiAccountTie,
  mdiGiftOffOutline,
  mdiWallet,
  mdiMessage,
  mdiHeadset
} from '@mdi/js';
// Component
import Can from '../../components/Can';
import AuthContext from '../../authContext';

// Type
import { MenuInterface, Menus } from './interfaces';

import windowSize from '../../utils/hook/useWindowResize';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: {
      color: '#fff',
    },
    toggleHolder: {
      height: '129px',
    },

    hideList: {
      display: 'none',
    },
    activePro: {
      '&:hover': {
        backgroundColor: '#DFA02E  !important',
      },
      textDecoration: 'none',
      backgroundColor: '#DFA02E',
    },
    item: {
      color: 'inherit',
      textDecoration: 'none',
    },
    sidebar: {
      // position: 'relative',
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      '@media (max-width: 768px)': {
        position: 'fixed',
        transform: 'translate(-100%, -100%)',
        zIndex: '9',
      },
    },
    sidebarOpenMob: {
      '@media (max-width: 768px)': {
        transform: 'none',
      },
    },
    sidebarCloseMob: {
      '@media (max-width: 768px)': {
        transform: 'translate(-100%, -100%)',
      },
    },
    drawer: {
      marginTop: '40px',
      marginBottom: '70px',
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      // overflowX: 'hidden',
      overflow: 'visible',
      background: theme.palette.primary.main,
      color: '#fff',
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    drawerClose: {
      // transition: theme.transitions.create('width', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),

      marginBottom: '7px',
      overflowX: 'hidden',
      // overflow: 'visible',
      width: theme.spacing(8) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
      background: theme.palette.primary.main,
      color: '#fff',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },

    nested: {
      '& > span': {
        paddingLeft: theme.spacing(7),
        fontSize: '14px !important',
      },
    },
    avatar: {
      margin: theme.spacing(6, 'auto', 7),
      height: '70px !important',
      // transition: theme.transitions.create('all', {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen,
      // }),
    },
    avatarLarg: {
      width: '148px',
      height: theme.spacing(15),
    },

    avatarSmall: {
      // marginTop: '54px',
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    avatarMob: {
      // marginTop: '54px',
      width: theme.spacing(0),
      height: theme.spacing(0),
    },
    userInfoContainer: {
      marginTop: 'auto',
      alignItems: 'center',
    },
    userInfoBox: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
      marginRight: '5px',
    },
    userInfoIconBox: {
      backgroundColor: '#345163',
      borderRadius: '4px',
      display: 'flex',
      // marginLeft: '5px',
    },
    userAvatar: {
      backgroundColor: '#345163',
      width: '43px',
      height: '43px',
    },
    username: {
      padding: theme.spacing(0, 1),
      fontSize: '16px',
      fontWeight: 500,
    },
    toolbar: {
      display: 'flex',
      position: 'relative',
      top: 0,
      backgroundColor: theme.palette.primary.main,
      // backgroundColor: 'red',
      zIndex: 20,

      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    toolbarOpen: {
      width: drawerWidth,
      alignItems: 'flex-start',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // transition: 'all .2s',
    },
    toolbarClose: {
      width: '73px',
      transition: theme.transitions.create(['all'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    toolbarCircle: {
      textAlign: 'center',
      display: 'flex',
      backgroundColor: theme.palette.background.default,
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      '@media (max-width: 768px)': {},
    },
    toolbarCircleSecound: {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '50%',
      width: '50px',
      height: '50px',
      margin: 'auto',
      '@media (max-width: 768px)': {},
    },
    divider: {
      backgroundColor: '#fff',
      margin: '0 16px',
    },
    mobMenu: {
      display: 'none',
      '@media (max-width: 768px)': {
        position: 'fixed',
        top: '0',
        right: '0',
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '64px',
        backgroundColor: theme.palette.primary.main,
        padding: '20px',
        zIndex: '10',
      },
    },
  })
);

// Const
const drawerWidth = 231;

export default function SideMenu(props: any) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const [open, setOpen] = React.useState(false);
  const [openConfirmLogoutBox, setOpenConfirmLogoutBox] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openMob, setOpenMob] = React.useState(false);

  const { width } = windowSize();

  useEffect(() => {
    if (width && width <= 1200) {
      setOpenDrawer(false);
    }
  }, [width]);

  const handleDrawerOpen = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleDrawerOver = () => {
    setOpenDrawer(true);
    // setOpen(true);
  };
  const handleDrawerLeave = () => {
    setOpenDrawer(false);
    setOpen(false);
  };

  const handleDrawerMobOpen = () => {
    setOpenMob(!openMob);
    setOpenDrawer(true);
  };

  const handleCollapse = (e: any, menu: any) => {
    menu.onClick && menu.onClick(e);
    setOpen(false);
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const getActiveSubMenu = (menu: any): boolean => {
    return (
      menu?.subMenu?.filter((menu: any) => {
        return window.location.pathname.includes(menu.path);
      }).length !== 0
    );
  };

  const getActiveSubMenuCurrent = (menu: any): boolean => {
    return (
      menu?.subMenu?.filter((menu: any) => {
        return window.location.pathname === menu.path;
      }).length !== 0
    );
  };

  const handleOpenConfirmLogoutBox = () => {
    setOpenConfirmLogoutBox(false);
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('partnerId');
    localStorage.removeItem('warehouseId');
    localStorage.removeItem('userId');
    localStorage.removeItem('name');
    window.location.href = '/login';
  };

  const handleLogout = (e: React.MouseEvent<unknown>) => {
    e.preventDefault();
    setOpenConfirmLogoutBox(true);
  };

  const menus: Menus = [
    {
      id: 11,
      path: "/orders",
      icon: mdiPackageVariant,
      sideMenuName: "مدیریت سفارش‌ها",
    },
    {
      id: 400,
      path: "/invoice",
      icon: mdiWallet,
      sideMenuName: "صورتحساب",
    },
    {
      id: 37,
      path: "/seller-orders",
      icon: mdiPackageVariant,
      sideMenuName: "مدیریت سفارش‌ها",
    },
    {
      id: 38,
      path: "/seller-parcels",
      icon: mdiClipboardArrowUpOutline,
      sideMenuName: "ارسال محموله",
    },
    {
      id: 21,
      path: "/parcels-sender",
      sideMenuName: "ارسال محموله",
      icon: mdiClipboardArrowUpOutline,
    },
    /*{
      id: 41,
      path: '/partner-account',
      sideMenuName: 'مدیریت اکانت',
      icon: mdiAccountTie,
    },*/
    {
      id: 36,
      path: "/vip-orders",
      icon: mdiStarBoxMultipleOutline,
      sideMenuName: "سفارش‌های ارسال ویژه",
    },
    {
      id: 34,
      path: "/nonPost-orders",
      icon: mdiPackageVariant,
      sideMenuName: "سفارش‌های لجستیک",
    },
    {
      id: 52,
      path: "/warehouse-admin-canceled-orders",
      sideMenuName: "سفارش های کنسل شده",
      icon: mdiGiftOffOutline,
    },
    {
      id: 29,
      path: "/post-orders",
      icon: mdiPackageVariant,
      sideMenuName: "مرسوله‌های پست",
    },
    {
      id: 33,
      path: "/pickups",
      sideMenuName: "لیست جمع آوری محموله",
      icon: mdiWarehouse,
    },
    {
      id: 31,
      path: "/fleets",
      icon: mdiCar,
      sideMenuName: "مدیریت ناوگان‌ها",
    },
    {
      id: 14,
      path: "/warehouse-admin-orders",
      icon: mdiPackageVariant,
      sideMenuName: "سفارش‌ها",
    },
    // {
    //   id: 15,
    //   path: '/delivery-orders',
    //   icon: mdiTruckDeliveryOutline,
    //   sideMenuName: 'تحویل سفارش‌ها',
    // },
    {
      id: 12,
      path: "/bundles-deliver",
      icon: mdiPackageVariantClosed,
      sideMenuName: "تحویل مرسوله‌ها",
    },
    {
      id: 73,
      path: "/bundles",
      icon: mdiPackageVariantClosed,
      sideMenuName: "مدیریت مرسوله‌ها",
    },
    {
      id: 313,
      path: "/messages",
      icon: mdiMessage,
      sideMenuName: "پیام ها",
    },
    {
      id: 315,
      path: "/ticketing",
      icon: mdiHeadset,
      sideMenuName: "تیکت‌ها",
    },
    {
      id: 13,
      path: "/assignment",
      icon: mdiClipboardArrowLeftOutline,
      sideMenuName: "تخصیص بسته به راننده",
    },
    {
      id: 35,
      path: "/drivers-wallet",
      sideMenuName: "کیف پول رانندگان",
      icon: mdiCar,
    },

    {
      id: 25,
      path: "/warehouse-zones",
      sideMenuName: "مدیریت بخش‌های انبار",
      icon: mdiWarehouse,
    },
    // {
    //   id: 2,
    //   path: '/upload-info',
    //   sideMenuName: 'بارگذاری اطلاعات',
    //   icon: mdiFileUploadOutline,
    // },
    {
      id: 7,
      path: "/warehouses-menu",
      sideMenuName: "مدیریت انبارها",
      icon: mdiWarehouse,
      subMenu: [
        {
          id: 7,
          path: "/warehouses",
          sideMenuName: "لیست انبارها",
          icon: mdiWarehouse,
        },
        {
          id: 15,
          path: "/parcels",
          sideMenuName: "محموله",
          icon: mdiPackageVariantClosed,
        },
        {
          id: 14,
          path: "/warehouses/inventory",
          sideMenuName: "موجودی",
          icon: mdiCounter,
        },
        {
          id: 19,
          path: "/centersStatistics",
          sideMenuName: "آمار سفارش‌ها",
          icon: mdiPackageVariant,
        },
      ],
    },
    {
      id: 39,
      path: "/warehouse/inventory",
      icon: mdiWarehouse,
      sideMenuName: "موجودی انبار",
      subMenu: [
        {
          id: 18,
          path: "/partner-warehouses/inventory",
          sideMenuName: "لیست موجودی انبار",
          icon: mdiCounter,
        },
        {
          id: 41,
          path: "/warehouses/product-history",
          sideMenuName: "تاریخچه کالا",
          icon: mdiHistory,
        },
      ],
    },
    {
      id: 23,
      path: "/your-centers",
      sideMenuName: "مدیریت مراکز",
      icon: mdiMapMarkerRadiusOutline,
    },
    {
      id: 22,
      path: "/your-products",
      sideMenuName: "مدیریت کالاها",
      icon: mdiArchiveOutline,
      subMenu: [
        {
          id: 22,
          path: "/your-products",
          sideMenuName: "کالاها",
          icon: mdiArchiveOutline,
        },
        {
          id: 30,
          path: "/providers",
          sideMenuName: "مدیریت تامین کنندگان",
          icon: mdiAccountSupervisor,
        },
        {
          id: 31,
          path: "/sellers",
          sideMenuName: "مدیریت فروشندگان",
          icon: mdiAccountSupervisor,
        },
      ],
    },
    {
      id: 42,
      path: "/seller-products",
      sideMenuName: "مدیریت کالاها",
      icon: mdiArchiveOutline,
    },
    {
      id: 38,
      path: "/webhooks",
      icon: mdiWeb,
      sideMenuName: "مدیریت وب هوک",
    },
    {
      id: 24,
      path: "/parcels-receipt",
      sideMenuName: " محموله‌های دریافتی",
      icon: mdiPackageVariantClosed,
    },
    {
      id: 25,
      path: "/warehouse-admin-parcels-receipts",
      sideMenuName: " محموله‌های دریافتی",
      icon: mdiPackageVariantClosed,
    },
    {
      id: 26,
      path: "/parcels-sender",
      sideMenuName: " محموله‌های ارسالی",
      icon: mdiPackageVariantClosed,
    },
    {
      id: 32,
      path: "/warehouse-operator-orders",
      sideMenuName: "سفارش‌های تخصیص داده شده",
      icon: mdiPackageVariant,
    },
    {
      id: 29,
      path: "/parcels-warehouse-operator",
      sideMenuName: "محموله",
      icon: mdiPackageVariantClosed,
    },
    {
      id: 6,
      path: "/partners",
      sideMenuName: "مدیریت شرکت‌ها",
      icon: mdiHandshake,
    },
    {
      id: 5,
      path: "/users",
      sideMenuName: "مدیریت کاربر‌ها",
      icon: mdiAccountMultipleOutline,
    },
    {
      id: 25,
      path: "/helpicalusers",
      sideMenuName: "مدیریت کاربر‌ها هلپیکال",
      icon: mdiAccountMultipleOutline,
    },
    // {
    //   id: 50,
    //   path: '/canceled-orders',
    //   sideMenuName: 'سفارش های کنسل شده',
    //   icon: mdiGiftOffOutline,
    // },
    // {
    //   id: 8,
    //   path: '/reports/current-orders',
    //   icon: mdiFileUploadOutline,
    //   sideMenuName: 'گزارشها',
    //   subMenu: [
    //     {
    //       id: 81,
    //       path: '/reports/current-orders',
    //       icon: mdiFileUploadOutline,
    //       sideMenuName: 'سفارش‌های جاری',
    //     },
    //   ],
    // },
    {
      id: 46,
      path: "/organize-bundles",
      icon: mdiPackageVariantClosed,
      sideMenuName: "سید بندی سفارش",
    },

    {
      id: 32,
      path: "/relocate",
      sideMenuName: "جابه‌جایی",
      icon: mdiWarehouse,
      subMenu: [
        {
          id: 7,
          path: "/relocate/by-item",
          sideMenuName: "جابه‌جایی آیتم انبار",
          icon: mdiWarehouse,
        },
      ],
    },
    {
      id: 3,
      path: "/login",
      sideMenuName: "خروج",
      icon: mdiExitToApp,
      onClick: handleLogout,
      dataCy: "logout",
    },
  ];

  const links = (
    <List>
      {menus.map((menu: MenuInterface, index: number) => {
        let activePro = '';
        if (
          menu.path === window.location.pathname ||
          window.location.pathname.includes(menu.path) ||
          (menu?.subMenu && getActiveSubMenu(menu))
        ) {
          activePro = `${classes.activePro} `;
        }
        const list = (
          <Can
            role={authContext.user.role}
            key={`${menu.id}_${index}`}
            perform={menu.path}
            yes={() => (
              <Link
                to={menu.path}
                key={`${menu.id}_${index}`}
                className={classes.item}
                onClick={e => handleCollapse(e, menu)}
              >
                <ListItem
                  button
                  // alignItems={'center'}
                  className={openDrawer ? activePro : ''}
                  style={
                    !openDrawer
                      ? {
                        paddingTop: '12px',
                        paddingBottom: '12px',
                      }
                      : {}
                  }
                  data-cy={menu?.dataCy}
                >
                  <ListItemIcon
                    className={!openDrawer ? activePro : ''}
                    style={
                      !openDrawer
                        ? {
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          minWidth: '40px',
                          paddingLeft: '2px',
                          paddingRight: '2px',
                          paddingTop: '5px',
                          paddingBottom: '5px',
                          borderRadius: '4px',
                        }
                        : {}
                    }
                  >
                    <Icon path={menu.icon} className={classes.icon} size={1} />
                  </ListItemIcon>
                  <ListItemText
                    className={!openDrawer ? classes.hideList : ''}
                    primary={menu.sideMenuName}
                  />
                </ListItem>
              </Link>
            )}
          />
        );
        const subList = (
          <div key={`${menu.id}_${index}`}>
            <Can
              role={authContext.user.role}
              perform={menu.path}
              key={`${menu.id}_${index}`}
              yes={() => (
                <ListItem
                  className={openDrawer ? activePro : ''}
                  button
                  key={`${menu.id}_${index}`}
                  onClick={handleClick}
                >
                  <ListItemIcon
                    className={!openDrawer ? activePro : ''}
                    style={
                      !openDrawer
                        ? {
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          minWidth: '40px',
                          paddingLeft: '1px',
                          paddingRight: '1px',
                          paddingTop: '6px',
                          paddingBottom: '6px',
                          borderRadius: '4px',
                        }
                        : {}
                    }
                  >
                    <Icon path={menu.icon} className={classes.icon} size={1} />
                  </ListItemIcon>
                  <ListItemText
                    style={{ fontSize: '4px' }}
                    className={!openDrawer ? classes.hideList : ''}
                    primary={menu.sideMenuName}
                  />
                  {openDrawer &&
                    (open ? (
                      <Icon path={mdiChevronUp} size={1} />
                    ) : (
                      <Icon path={mdiChevronDown} size={1} />
                    ))}
                </ListItem>
              )}
            />

            {
              <Collapse in={open} timeout="auto" unmountOnExit key={index}>
                <List component="div" disablePadding>
                  {menu.subMenu &&
                    menu.subMenu.map((menu, index) => {
                      let activePro = '';
                      if (menu.path === window.location.pathname) {
                        activePro = `${classes.activePro} `;
                      }

                      return (
                        <Can
                          role={authContext.user.role}
                          perform={menu.path}
                          key={`${menu.id}_${index}`}
                          yes={() => (
                            <Link
                              to={menu.path}
                              className={classes.item}
                              key={`${menu.id}_${index}`}
                            >
                              <ListItem
                                button
                                className={activePro + classes.nested}
                              >
                                <ListItemText
                                  className={
                                    !openDrawer
                                      ? classes.hideList
                                      : classes.nested
                                  }
                                  primary={menu.sideMenuName}
                                />
                              </ListItem>
                            </Link>
                          )}
                        />
                      );
                    })}
                </List>
              </Collapse>
            }
          </div>
        );

        if (!menu.subMenu) {
          return list;
        } else {
          return subList;
        }
      })}
    </List>
  );

  return (
    <div
      style={{
        position: 'relative',
        paddingRight: openDrawer ? '73px' : '0px',
      }}
    >
      <div className={classes.mobMenu}>
        <IconButton onClick={handleDrawerMobOpen}>
          {!openMob ? (
            <Icon path={mdiMenu} className={classes.icon} size={1} />
          ) : (
            <Icon path={mdiClose} className={classes.icon} size={1} />
          )}
        </IconButton>
      </div>

      <div
        style={{ position: openDrawer ? 'fixed' : 'relative', zIndex: 100 }}
        className={clsx(classes.sidebar, {
          [classes.sidebarOpenMob]: openMob,
          [classes.sidebarCloseMob]: !openMob,
        })}
      >
        <Drawer
          open={openDrawer}
          onMouseOver={handleDrawerOver}
          onMouseLeave={handleDrawerLeave}
          variant={'permanent'}
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            }),
          }}
        >
          <div
            className={clsx(classes.toolbar, {
              [classes.toolbarOpen]: openDrawer,
              [classes.toolbarClose]: !openDrawer,
            })}
          // style={openDrawer ? {width: drawerWidth} : {}}
          >
            {!openDrawer ? (
              <Avatar
                variant="rounded"
                className={clsx(classes.avatar, {
                  [classes.avatarSmall]: !openDrawer,
                  [classes.avatarMob]: openMob,
                })}
                src="/logo2.png"
                sizes="sm"
              />
            ) : (
              <Avatar
                variant="rounded"
                className={clsx(classes.avatar, {
                  [classes.avatarLarg]: openDrawer,
                  [classes.avatarMob]: openMob,
                })}
                src="/logo.png"
                sizes="sm"
              />
            )}
          </div>

          <div className={classes.toggleHolder}></div>
          {links}
          <div className={classes.userInfoContainer}>
            <div className={classes.userInfoBox}>
              <Avatar variant="rounded" className={classes.userAvatar} />
              <div className={classes.username}>
                <Link to="profile" style={{ color: "#fff", textDecoration: "none" }}>
                  {openDrawer && authContext.user.name}
                </Link>
              </div>
            </div>
          </div>

          <Dialog
            fullWidth
            open={openConfirmLogoutBox}
            onClose={() => setOpenConfirmLogoutBox(false)}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle>{' از خروج از پنل ادمین اطمینان دارید؟'}</DialogTitle>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => setOpenConfirmLogoutBox(false)}
                color="primary"
              >
                {'خیر'}
              </Button>
              <Button
                onClick={handleOpenConfirmLogoutBox}
                variant="contained"
                color="primary"
                data-cy="logout-click"
              >
                {'بله'}
              </Button>
            </DialogActions>
          </Dialog>
        </Drawer>
      </div>
    </div>
  );
}
